import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import useAlert from 'hooks/useAlert';
import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { SALES_CHANNELS } from 'services/consts';

import AppLogger from 'utils/AppLogger';
import PATHS, { mergePaths } from 'utils/paths';

const useAuthorize = () => {
	const axiosPrivate = useAxiosPrivate();
	const { showError, showSuccess } = useAlert();
	const [authorizeLoading, setAuthorizeLoading] = useState(false);
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const { salesChannel } = useSelector((state) => state.salesChannel);
	const authorize = useCallback(
		async (data) => {
			setAuthorizeLoading(true);
			try {
				const response = await axiosPrivate.post(SALES_CHANNELS.AUTHORIZE_SALES_CHANNEL, {
					queryParams: Object.fromEntries(searchParams),
					ecomType: salesChannel.integrationName,
					...data
				});

				if (response.status === 200) {
					if (salesChannel.slug !== 'salla-automation') {
						if (response.data.success) {
							showSuccess();
							if (salesChannel.slug !== 'salla-automation') {
								navigate(mergePaths(PATHS.SALES_CHANNELS, PATHS.CONNECTED_STORES));
							}
						} else {
							showError();
							AppLogger.error(response);
						}
					}
					return response.data;
				} else {
					AppLogger.error(response);
				}
			} catch (error) {
				AppLogger.error(error);
				if (error.response?.data) {
					showError({
						message: error.response.data?.code
					});
				} else showError();
			} finally {
				setAuthorizeLoading(false);
			}
		},
		[salesChannel]
	);

	useEffect(() => {
		if (
			salesChannel?.authorize &&
			searchParams.toString() &&
			!searchParams.has('oto-token') &&
			!searchParams.has('modal')
		) {
			authorize();
		}
	}, [searchParams, salesChannel]);

	return { authorizeLoading, authorize };
};

export default useAuthorize;
